<template>
    <div class="buy-ticket">
          <router-link :to="goTo">
              <div class="movie-gradient buy" :class="{'cancel':cancel}">{{text}}</div>
          </router-link>
    </div>
</template>

<script>
export default {
    name:"MovieBottomButton",
    props:{
        text:'',
        goTo:{
            default: {}
        },
        cancel: {
            default: false
        }
    }
}
</script>

<style scoped>
.buy-ticket{
    width:100%;
    height:1.2rem;
    box-sizing: border-box;
    padding:.18rem .3rem;
    position:fixed;
    bottom:0;
}
.buy{
    width:100%;
    height:100%;
    box-shadow: 0 .04rem .18rem 0 rgba(255, 0, 62, 0.29);
    border-radius: .42rem;
    font-size: .36rem;
    font-weight: 400;
    color: #FFFFFF;
    text-align:center;
    line-height:.9rem;
}
.cancel {
    background: #ddd;
    cursor:"no-drop";
    box-shadow: 0 0 0 0 transparent;
}

</style>